import { render, staticRenderFns } from "./mandala-header.component.vue?vue&type=template&id=4c99b8ee&scoped=true&"
import script from "./mandala-header.component.vue?vue&type=script&lang=ts&"
export * from "./mandala-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./mandala-header.component.vue?vue&type=style&index=0&id=4c99b8ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99b8ee",
  null
  
)

export default component.exports